import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from '@app/shared/directives/click-outside.directive';
import { DebounceClickDirective } from '@app/shared/directives/debounce-click.directive';
import { InterceptInvokerDirective } from '@app/shared/directives/intercept-invoker.directive';
import { LazyLoadingDirective } from '@app/shared/directives/lazy-loading.directive';
import { IfContentChangedDirective } from '@app/shared/directives/if-content-changed.directive';
import { ShortingStringDirective } from '@app/shared/directives/shorting-string.directive';
import { ClearDirective } from '@app/shared/controls/directives/clear.directive';
import { TrimValueDirective } from '@app/shared/controls/directives/trim-value.directive';
import { AddTextPaginationDirective } from '@app/shared/grid/directives/add-text-pagination.directive';
import { GridOptionalFeaturesDirective } from '@app/shared/grid/directives/grid-optional-features.directive';
import { GridDynamicPageSizeDirective } from '@app/shared/grid/directives/grid-dynamic-page-size.directive';
import { GridRowEventListenerDirective } from '@app/shared/grid/directives/grid-row-event-listener.directive';
import { SortableGridItemsDndDirective } from '@app/shared/grid/directives/sortable-grid-items-dnd.directive';
import { DropDownButtonDirective } from '@app/extensions/kendo/directives/dropdown-button.directive';
import { TabContentLoadOnDemandDirective } from '@app/extensions/kendo/directives/tab-content-load-on-demand.directive';
import { TabstripNavigationDirective } from '@app/extensions/kendo/directives/tabstrip-navigation.directive';
import { KendoDropDownEnterPressDirective } from '@app/extensions/kendo/directives/kendo-dropdown-enter-press.directive';
import { KendoDropDownTooltipDirective } from '@app/extensions/kendo/directives/kendo-dropdown-tooltip.directive';
import { ClickTodayButtonDirective } from '@app/extensions/kendo/directives/click-today-button.directive';
import { ClickNowButtonDirective } from '@app/extensions/kendo/directives/click-now-button.directive';
import { KendoDropdownChunkLoadingDirective } from '@app/extensions/kendo/directives/kendo-dropdown-chunk-loading.directive';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { OverflowTooltipDirective } from '@tpt/common/tooltips/overflow';
import { StopAnimationDirective } from '@app/shared/directives/stop-animation.directive';
import { HideAfterTimeoutDirective } from '@app/shared/directives/hide-after-timeout.directive';
import { DisplayNoneDirective } from '@app/shared/directives/display-none.directive';
import { FocusWithinDirective } from '@app/shared/directives/focus-within.directive';
import { ModalGeometryChangeDirective } from '@app/shared/directives/modal-geometry-change.directive';
import { CloseCalendarOnBlurDirective } from '@app/shared/directives/close-calendar-on-blur.directive';
import { GridDragAndDropDirective } from '@app/shared/directives/grid-drag-and-drop.directive';

const directives = [
  StopAnimationDirective,
  HideAfterTimeoutDirective,
  ClickOutsideDirective,
  ClearDirective,
  DropDownButtonDirective,
  AddTextPaginationDirective,
  DebounceClickDirective,
  TabContentLoadOnDemandDirective,
  GridOptionalFeaturesDirective,
  GridDynamicPageSizeDirective,
  GridRowEventListenerDirective,
  TabstripNavigationDirective,
  DisplayNoneDirective,
  InterceptInvokerDirective,
  KendoDropDownEnterPressDirective,
  FocusWithinDirective,
  SortableGridItemsDndDirective,
  ModalGeometryChangeDirective,
  LazyLoadingDirective,
  IfContentChangedDirective,
  TrimValueDirective,
  ShortingStringDirective,
  ClickTodayButtonDirective,
  ClickNowButtonDirective,
  CloseCalendarOnBlurDirective,
  GridDragAndDropDirective,
];

@NgModule({
  declarations: directives,
  imports: [TooltipModule, OverflowTooltipDirective, KendoDropdownChunkLoadingDirective, KendoDropDownTooltipDirective],
  exports: [...directives, KendoDropdownChunkLoadingDirective, KendoDropDownTooltipDirective],
})
export class DirectivesModule {}
